import { useEffect, useState } from "react";
import {  getPersons, personCreate, deletePerson, getCardsList } from "../../../pages/api/sportcards";
import { useStore } from "../../../stores/use_global_state";
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import Image from "next/image";

const ChoosePerson = ({ sportCardsState, setSportCardsState, setSteps }) => {
  const { state } = useStore();
  let token = state?.userInfo?.token ? state.userInfo.token : false;
  const [persons, setPersons] = useState([]);
  const [activePerson, setActivePerson] = useState(null);
  const [createNewActive, setcreateNewActive] = useState(false);
  const [newPersonName, setNewPersonName] = useState("");

  useEffect(() => {
    const getPersonList = async () => {
      if (!token) return;
      const response = await getPersons(token);
      setPersons(response.data);
    };
    getPersonList();
  }, [state]);

  const createNewPerson = async () => {
    if (!token) return;
    await personCreate({ name: newPersonName }, token);
    const response = await getPersons(token);
    setPersons(response.data);
    setcreateNewActive(false);
    setNewPersonName("")
  }

  const next = async () => {
    const { data } = await getCardsList(activePerson.id, token);

    setSportCardsState({ ...sportCardsState, person: { ...activePerson, cards: data } });

    if (data.length > 0) { return setSteps(prev => prev.map(step => step.name === "Download" ? { ...step, active: true } : { ...step, active: false })) }
    if (activePerson.status !== "CREATED") { return setSteps(prev => prev.map(step => step.name === "Template" ? { ...step, active: true } : { ...step, active: false })) }
  }

  const hendleDeliteItem = async () => {
    if (!token) return;
    await deletePerson(activePerson.id, token);
    const response = await getPersons(token);
    setPersons(response.data);
  }

  return (
    <>
      <div className={styles.choosePersonWrapper} style={{ justifyContent: createNewActive ? "center" : "flex-start" }}>
        {!createNewActive && <button className={`${styles.choosePersonBtn} ${styles.choosePersonBtnNew}`} onClick={() => { setcreateNewActive(true); setNewPersonName("") }}>
          <HandySvg className={styles.choosePersonBtnNewPlus} src="/sport_cards/plus.svg" width="24" height="24" />
          <p className={styles.choosePersonBtnNewText}>Add new</p>
        </button>}
        {createNewActive && <div className={`${styles.choosePersonBtn}`} style={{ zIndex: 10 }}>
          <button aria-label="close" className={styles.choosePersonBtnClose} onClick={() => setcreateNewActive(false)}><HandySvg src={"/survey/close.svg"} width={12} height={12} className={`${open ? styles.open : ""}`} fill={"transparent"} /></button>
          <Image className={styles.choosePersonBtnImg} src={"/sport_cards/person.png"} alt="person" width="100" height="100" quality={99} unoptimized />
          <div className={styles.choosePersonBtnInput}>
            <input type="text" name="name" id="" value={newPersonName} onChange={(e) => setNewPersonName(e.target.value)} />
            <button onClick={createNewPerson} aria-label="create new percon" disabled={newPersonName.length < 1}><HandySvg src={"/sport_cards/done.svg"} width={16} height={16} className={`${open ? styles.open : ""}`} fill={"transparent"} /></button>
          </div>
        </div>}
        {!createNewActive && persons.map((person) => (
          <div style={{ position: "relative", zIndex: person.id === activePerson?.id ? "10" : "1" }} key={person.id}>
            {person.id === activePerson?.id && <button aria-label="close" className={styles.choosePersonBtnClose} onClick={hendleDeliteItem}><HandySvg src={"/survey/close.svg"} width={12} height={12} className={`${open ? styles.open : ""}`} fill={"transparent"} /></button>}
            <button key={person.id} onClick={() => setActivePerson(person)} className={`${styles.choosePersonBtn} ${person.id === activePerson?.id ? styles.choosePersonBtnActive : ""}`}>
              <Image className={styles.choosePersonBtnImg} src={person.image_url || "/sport_cards/person.png"} alt="person" width="100" height="100" quality={99} unoptimized />
              <p className={styles.choosePersonBtnName}>{person.name}</p>
            </button>
          </div>
        ))
        }
      </div >
      <div className={`${styles.choosePersonInfo} `}>
        <Image src={"/sport_cards/cards.png"} alt="empty" width="68" height="68" quality={99} />
        <p>
          You can create cards not only for yourself, but also for other people.<br />{" "}
          Generating the <span>1st card</span> for each person costs <span>10 credits</span>, each subsequent card costs 1 credit
        </p>
      </div>
      {activePerson !== null && <button onClick={next} className={styles.nextBtn}>Next <HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} /></button>}
    </>
  )
}

export default ChoosePerson